module.exports = __webpack_public_path__ + "media/images/upload-portfolio-icon-72f4ba93870fd3d3d93d5dcb0e8ce329.svg";